import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "type",
    "section",
    "pathology",
    "pathologyWrapper",
    "sectionableType",
    "sectionableId"
  ]

  static values = {
    options: Object,
    initialType: String,
    initialSectionId: String,
    initialPathologyId: String
  }

  connect () {
    if (this.hasTypeTarget && this.initialTypeValue) {
      this.typeTarget.value = this.initialTypeValue
    }

    this.refreshSections({ preserveSelection: true })
  }

  typeChanged () {
    this.refreshSections({ preserveSelection: false })
  }

  sectionChanged () {
    if (this.typeTarget.value === "Pathology") {
      this.refreshPathologies({ preserveSelection: false })
    }

    this.syncHiddenFields()
  }

  pathologyChanged () {
    this.syncHiddenFields()
  }

  refreshSections ({ preserveSelection }) {
    const type = this.typeTarget.value
    this.sectionableTypeTarget.value = type

    const sections = this.sectionsFor(type)
    const previous = preserveSelection
      ? (this.initialSectionIdValue || this.sectionTarget.value)
      : null

    this.sectionTarget.innerHTML = sections
      .map((section) => `<option value="${section.id}">${this.escapeHtml(section.title)}</option>`)
      .join("")

    if (previous && sections.some((section) => String(section.id) === String(previous))) {
      this.sectionTarget.value = previous
    }

    this.togglePathology(type === "Pathology")

    if (type === "Pathology") {
      this.refreshPathologies({ preserveSelection })
    } else {
      this.syncHiddenFields()
    }
  }

  refreshPathologies ({ preserveSelection }) {
    const categoryId = this.sectionTarget.value
    const pathologies = this.pathologiesFor(categoryId)
    const previous = preserveSelection
      ? (this.initialPathologyIdValue || this.pathologyTarget.value)
      : null

    this.pathologyTarget.innerHTML = pathologies
      .map((pathology) => `<option value="${pathology.id}">${this.escapeHtml(pathology.title)}</option>`)
      .join("")

    if (previous && pathologies.some((pathology) => String(pathology.id) === String(previous))) {
      this.pathologyTarget.value = previous
    }

    this.syncHiddenFields()
  }

  togglePathology (visible) {
    if (!this.hasPathologyWrapperTarget) return

    this.pathologyWrapperTarget.classList.toggle("d-none", !visible)

    // Hidden + required blocks HTML5 submit with no visible validation UI.
    if (this.hasPathologyTarget) {
      this.pathologyTarget.required = visible
    }
  }

  syncHiddenFields () {
    this.sectionableTypeTarget.value = this.typeTarget.value

    if (this.typeTarget.value === "Pathology") {
      this.sectionableIdTarget.value = this.pathologyTarget.value
    } else {
      this.sectionableIdTarget.value = this.sectionTarget.value
    }
  }

  sectionsFor (type) {
    if (type === "Pathology") {
      return this.optionsValue.Pathology?.categories || []
    }

    return this.optionsValue[type] || []
  }

  pathologiesFor (categoryId) {
    return this.optionsValue.Pathology?.by_category_id?.[categoryId] || []
  }

  escapeHtml (value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
  }
}
